import EventItem from "./eventItemEntity";

export default class EventItemDto {
    public limit: number;
    public skip: number;
    public total: number;
    public eventItems: EventItem[];
  
    constructor() {
      this.limit = 0;
      this.skip = 0;
      this.total = 0;

      this.eventItems = [];
    }
  }


// WEBPACK FOOTER //
// ./src/api/eventItemDto.ts